import { Control } from "react-hook-form";

import { SelectBuyerList } from "components/form_components/BuyerListSelect";
import { BuyerSelect } from "components/form_components/BuyerSelect";
import { BuyerTypeSelect } from "components/form_components/BuyerTypeSelect";
import { CountryRegionSelect } from "components/form_components/CountryRegionSelect";
import Divider from "components/ui/divider/Divider";
import { FilterOptions } from "../FilterForm";
import { DocumentFilters } from "../utils";

import css from "./SharedFilterGroups.module.scss";

export interface BuyersFilterContentProps {
  control: Control<DocumentFilters, unknown>;
  data: DocumentFilters;
  options?: FilterOptions;
}

function BuyersFilterContent({ control, data, options }: BuyersFilterContentProps) {
  return (
    <div className={css.filterSection} aria-label="Buyer filters">
      <BuyerSelect
        name="organisationIds"
        label="Buyers"
        control={control}
        mode="multiple"
        placeholder="Search buyers"
        disabled={
          (data.buyerListIds !== undefined && data.buyerListIds.length > 0) ||
          options?.disabledFields?.includes("organisationIds")
        }
        allowClear
      />
      <Divider />
      <SelectBuyerList
        name="buyerListIds"
        label="Buyer lists"
        control={control}
        placeholder="Select lists"
        mode="multiple"
        disabled={
          (data.organisationIds !== undefined && data.organisationIds.length > 0) ||
          options?.disabledFields?.includes("buyerListIds")
        }
        allowClear
      />
      <BuyerTypeSelect
        name="buyerTypes"
        control={control}
        multiple
        label="Buyer type"
        placeholder="Select"
        disabled={options?.disabledFields?.includes("buyerTypes")}
        allowClear
      />
      <CountryRegionSelect
        name="buyerCountryRegions"
        control={control}
        label="Buyer location"
        placeholder="Select..."
        disabled={options?.disabledFields?.includes("buyerCountryRegions")}
        allowClear
      />
    </div>
  );
}

export default BuyersFilterContent;
